"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _api = require("../helpers/api.js");
var _constants = require("../constants");
var QuestionBankProducts = /*#__PURE__*/_createClass(function QuestionBankProducts(api) {
  var _this = this;
  _classCallCheck(this, QuestionBankProducts);
  this.getProductsFetchKey = function (selectedQuestionBankId) {
    return "products-fetch/".concat(selectedQuestionBankId);
  };
  this.productsFetch = function () {
    return function (dispatch, getState) {
      var _getState = getState(),
        session = _getState.session,
        loading = _getState.loading;
      var key = _this.getProductsFetchKey(session.get('selected_question_bank_id'));
      if (loading.has(key)) return loading.get(key);
      var promise = _this.api.get("".concat((0, _api.selectedQuestionBankUrl)(getState()), "/products")).then(function (response) {
        dispatch({
          type: _constants.PRODUCTS_FETCHED,
          payload: _objectSpread({
            key: key
          }, response)
        });
        return response;
      }).catch(function (error) {
        dispatch({
          type: _constants.PRODUCTS_ERROR,
          payload: {
            error: error,
            key: key
          }
        });
        throw error;
      });
      dispatch({
        type: _constants.PRODUCTS_LOADING,
        payload: {
          key: key,
          promise: promise
        }
      });
      return promise;
    };
  };
  this.api = api;
});
;
var _default = exports.default = QuestionBankProducts;